 @if (open) {
<form [formGroup]="formGroup" mgdEnhancedForm class="form" id="formGroup" #mgdEnhancedForm="mgdEnhancedForm" >
    <div class="fields-wrapper">
        <ng-content></ng-content>
    </div>
    <div class="mgd-card-form-actions">
    <button mgdButton mat-fab extended class="fab" (click)="onCancel()">
    <mat-icon>cancel</mat-icon>
        Cancel
    </button>
    @if (index !== null && index >= 0) {
        <button mgdButton mgdButtonType="save" [enhancedForm]="mgdEnhancedForm" mat-fab extended class="fab" (click)="onSubmitClick()">
            <mat-icon>edit_note</mat-icon>
            Update
        </button>
    } @else {
        <button mgdButton mgdButtonType="save" [enhancedForm]="mgdEnhancedForm" mat-fab extended class="fab" (click)="onSubmitClick()">
        <mat-icon>docs_add_on</mat-icon>
            Add
        </button>
    }
   
    </div>
</form>
 }
